import axios from "axios";
import qs from "qs";
import { error } from "shelljs";
import config from "../../config/config.js";
import { Message } from "element-ui";
import router from "@/router";
var URI = config.apiurl;

var ax = axios.create({
  baseURL: URI,
  // timeout: 50000,
  headers: {
    // 'Content-Type':'application/x-www-form-urlencoded',
    // 'TOKEN': ''
  }
});

export var itr = (type, url, params) => {
  if (typeof params !== "object") {
    params = {};
  }
  let arg = qs.stringify(params);
  return ax[type](url, arg);
};

// Ajax API start
export const g = (url, params) => {
  return base("get", url, params);
};

export const p = (url, params, mask, clear, silent) => {
  return base("post", url, params, mask, clear, silent);
};

export const d = (url, params) => {
  return base("delete", url, params);
};

export const u = (url, params) => {
  return base("put", url, params);
};
export const pa = (url, params) => {
  return base("patch", url, params);
};

export const op = (url, params) => {
  return base("options", url, params);
};
// Ajax API end

export function base(
  type,
  url,
  params,
  mask = false,
  clear = true,
  silent = false
) {
  return new Promise((resolve, reject) => {
    itr(type, url, params)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      })
      .catch(msg => {
        if (!msg.response) {
          // alert('服务器连接超时')
        } else {
          // alert(msg.response.status + ':' + msg.response.statusText)
        }
        reject(msg.message);
      });
  });
}

// ----------------------------------------------传json
var axJson = axios.create({
  baseURL: URI,
  timeout: 20000,
  headers: {
    "Content-Type": "application/json"
  }
});

//每次发送请求都携带token
axJson.interceptors.request.use(
  config => {
    // var token = sessionStorage.getItem("token");
    // if (token) {
    //   config.headers.TOKEN = true
    // config.headers.Authorization = 'bearer 72e7cc81-3f8d-4c78-91f9-82a6f7289f69';
    //每次访问携带token
    // }
    var token = localStorage.getItem("partnerplan_access_token");
    config.headers.Authorization = "bearer " + token;
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

axJson.interceptors.response.use(
  data => {
    //console.log("返回信息",data)

    // if(data.status==401){
    //   this.$message.error('登录失效,请重新登录');
    //   //移除登录人信息
    // }
    // router.push({path: '/'});

    return data;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          Message({
            message: "登录失效,请重新登录",
            type: "error",
            duration: 1000
          });
          sessionStorage.clear();
          localStorage.clear();
          router.push({ name: "login" });
        case 404:
          // 返回 401 清除token信息并跳转到登录页面
          Message({
            message: "系统错误",
            type: "error",
            duration: 1000
          });
      }
    }
    console.log("认证失败", error);
    return Promise.reject(error);
  }
);

// axJson.interceptors.request.use(config => {
//   var token = sessionStorage.getItem("token");
//   if (token) {
//     config.headers.TOKEN = true
//     config.headers.Authorization = 'Bearer ' + sessionStorage.token
//     //每次访问携带token
//   }
//   return config;
// },
//   err => { return Promise.reject(err); })

// // 全局拦截
// axJson.interceptors.response.use(data => {
//   return data
// }, error => {
//   console.log('认证失败', error)
//   return Promise.reject(error)
// })

export var itrJson = (type, url, params) => {
  if (typeof params !== "object") {
    params = {};
  }
  let arg = JSON.stringify(params);
  // let arg = qs.stringify(params)
  return axJson[type](url, arg);
};

// Ajax API start
export const pJson = (url, params, mask, clear, silent) => {
  return baseJson("post", url, params, mask, clear, silent);
};
// Ajax API end

export function baseJson(
  type,
  url,
  params,
  mask = false,
  clear = true,
  silent = false
) {
  return new Promise((resolve, reject) => {
    itrJson(type, url, params)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      })
      .catch(msg => {
        if (!msg.response) {
          // alert('服务器连接超时')
        } else {
          // alert(msg.response.status + ':' + msg.response.statusText)
        }
        reject(msg.message);
      });
  });
}

// ----------------------------------------------传Blob
var axJsonBlob = axios.create({
  baseURL: URI,
  timeout: 20000,
  headers: {
    "Content-Type": "application/json"
  }
});

export var itrJsonBlob = (type, url, params) => {
  if (typeof params !== "object") {
    params = {};
  }
  let arg = JSON.stringify(params);
  // let arg = qs.stringify(params)
  return axJsonBlob[type](url, arg);
};

// Ajax API start
export const pJsonBlob = (url, params, mask, clear, silent) => {
  return baseJsonBlob("post", url, params, mask, clear, silent);
};
// Ajax API end

export function baseJsonBlob(
  type,
  url,
  params,
  mask = false,
  clear = true,
  silent = false
) {
  return new Promise((resolve, reject) => {
    itrJsonBlob(type, url, params)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.data);
        }
      })
      .catch(msg => {
        if (!msg.response) {
          // alert('服务器连接超时')
        } else {
          // alert(msg.response.status + ':' + msg.response.statusText)
        }
        reject(msg.message);
      });
  });
}



// WEBPACK FOOTER //
// ./src/api/instrance.js